(function () {
  const section = document.querySelector('[data-section-type="collection-template"]');

  if (!section) return;

  const sectionId = section.dataset.sectionId;

  if (!sectionId) return;

  let isLoading = false;

  function buildSectionUrl(url) {
    const nextUrl = new URL(url, window.location.origin);

    nextUrl.searchParams.set('section_id', sectionId);

    return nextUrl.toString();
  }

  async function loadCollection(url, pushState = true) {
    if (isLoading) return;

    isLoading = true;
    section.classList.add('is-loading');

    try {
      const response = await fetch(buildSectionUrl(url), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = parsed.querySelector('#CollectionProductGrid');
      const currentGrid = document.querySelector('#CollectionProductGrid');

      const newSidebar = parsed.querySelector('.m-sidebar');
      const currentSidebar = document.querySelector('.m-sidebar');

      if (newGrid && currentGrid) {
        currentGrid.innerHTML = newGrid.innerHTML;
      }

      if (newSidebar && currentSidebar) {
        currentSidebar.innerHTML = newSidebar.innerHTML;
      }

      if (pushState) {
        window.history.pushState({}, '', url);
      }

      if (typeof Collection !== 'undefined') {
        window.MinimogTheme.Collection = new Collection();
        window.MinimogTheme.Collection.init();
      }

      document.dispatchEvent(
        new CustomEvent('mmg:collection:updated', {
          bubbles: true
        })
      );
    } catch (error) {
      console.error('AJAX collection error:', error);
      window.location.href = url;
    } finally {
      isLoading = false;
      section.classList.remove('is-loading');
    }
  }

  function shouldHandleUrl(url) {
    if (!url) return false;

    const nextUrl = new URL(url, window.location.origin);

    return (
      nextUrl.pathname.includes('/collections/') ||
      nextUrl.search.includes('filter.') ||
      nextUrl.search.includes('sort_by') ||
      nextUrl.search.includes('page=')
    );
  }

  document.addEventListener('click', function (event) {
    const link = event.target.closest(
      '[data-ajax-collection-link], .mmg-collection-categories a, [data-collection-link], .m-pagination a'
    );

    if (!link) return;

    const url = link.getAttribute('href');

    if (!url || url === '#' || link.target === '_blank') return;
    if (!shouldHandleUrl(url)) return;

    event.preventDefault();

    loadCollection(url);
  });

  document.addEventListener('change', function (event) {
    const input = event.target.closest(
      '.m-filter--wrapper input, .m-filter--wrapper select'
    );

    if (!input) return;

    const form = input.closest('form');

    if (!form) return;

    event.preventDefault();

    const formData = new FormData(form);
    const params = new URLSearchParams(formData);
    const url = `${window.location.pathname}?${params.toString()}`;

    loadCollection(url);
  });

  window.addEventListener('popstate', function () {
    loadCollection(window.location.href, false);
  });
})();